export enum Language {
  EN = 'en',
  CY = 'cy',
}

export const languages = () => {
  return Object.keys(Language).map((lang) => Language[lang]);
};
